// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b71c765b","858":"a428e1f4"}[chunkId] + ".chunk.js";
};